module.exports = "<router-outlet></router-outlet>\r\n<app-footer></app-footer>"